import React from "react";

import { Box, Typography } from "@mui/material";
import type { CardConfig, TextCardConfig } from "store/types";

import { SectionLabel } from "./SectionLabel";

interface Props {
  config: TextCardConfig;
  onUpdateConfig: (c: CardConfig) => void;
}

export const TextSettings: React.FC<Props> = () => {
  return (
    <Box>
      <SectionLabel>Text Content</SectionLabel>
      <Typography sx={{ fontSize: 12, color: "#6B7280", lineHeight: 1.6 }}>
        Edit text directly on the card canvas using the inline toolbar for formatting options.
      </Typography>
    </Box>
  );
};
